import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {XMLHttpRequestHandler, XMLHttpRequestHandler_requestType} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {triviaListEdit_template} from "../components/templates/triviaListEdit_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {header} from "./header";

declare var ko: any;
declare var page: any;

export class trivia_list_edit extends vnModule_knockoutJS {

    protected triviaEdit: triviaListEdit_template;
    protected XHRHdl: XMLHttpRequestHandler;
    protected _isLeavePageWarningNeeded: boolean = true;

    buildContent(): Array<Element> {
        this.triviaEdit = new triviaListEdit_template('triviaEdit', this.viewModel, this);
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Daily Trivia");
        return [this.triviaEdit.build()];
    }

    protected getModuleName(): string {
        return "trivia_list_edit";
    }

    public fillPage() {
        const id = this.getVnAppZone().app.params.id;
        if (id) {
            this.getTriviaDataForEdit(id);
        }
    }

    protected getTriviaDataForEdit(id: string) {
        this.loadingIn(this.triviaEdit.builtTemplate);

        let url    = '/api/brand/' + this.getBrandId() + '/trivia/get/' + id + '/';
        this.XHRHdl = new XMLHttpRequestHandler(url, [], this);
        this.XHRHdl.onReadyStateFunction = this.onGetTriviaDataReturn;
        this.XHRHdl.execute();
    }

    protected onGetTriviaDataReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const responseParsed = JSON.parse(req.request.response);
                obj.setTriviaData(responseParsed.data);
            });
            obj.loadingOut(obj.triviaEdit.builtTemplate);
        }
    }

    protected setTriviaData(trivia: any) {
        this.triviaEdit.setId(trivia.id          || null);
        this.triviaEdit.setTriviaDate(trivia.triviaDate || '');
        this.triviaEdit.setTitle(trivia.title    || '');
        this.triviaEdit.setQuestions(trivia.questions || []);

        // Disable date field for existing records (date is their identity).
        if (trivia.id) {
            this.triviaEdit.setDateDisabled(true);
        }
    }

    public cancelForm() {
        this.onClickCancelEdit();
    }

    public onClickCancelEdit() {
        page.redirect('/brand/' + this.getBrandId() + '/trivia-lists/');
    }

    protected save() {
        this.loadingIn(this.triviaEdit.builtTemplate);

        let url    = '/api/brand/' + this.getBrandId() + '/trivia/save/';
        let params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON(this.triviaEdit.getViewModelForRequest())]);

        let XHRHdl = new XMLHttpRequestHandler(url, params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {
            return function () {
                if (req.request.readyState == 4 && req.request.status == 400) {
                    let responseParsed = JSON.parse(req.request.response);
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_ERROR, responseParsed.error || 'Validation error.');
                    obj.getVnAppZone().showNotificationToModule();
                    obj.loadingOut(obj.triviaEdit.builtTemplate);
                    return;
                }
                obj.manageResponse(req, obj, function () {
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, 'Trivia saved!');
                    page.redirect('/brand/' + obj.getBrandId() + '/trivia-lists/');
                });
                obj.loadingOut(obj.triviaEdit.builtTemplate);
            }
        });
        XHRHdl.execute();
    }

    public getBrandId() {
        return this.getVnAppZone().app.params.idBrand;
    }
}



// WEBPACK FOOTER //
// ./js/modules/trivia_list_edit.ts